module.exports = __webpack_public_path__ + "img/saude.8c62c581.svg";